import React from 'react'
import { CSSTransition } from 'react-css-transition'
import { FormattedMessage } from 'react-intl'
import TransitionStyles from '../../lib/transitionStyles'

const GiftcardsOrderCompleted = ({ email, stripeOrder }) => (
  <div className="container mx-auto md:my-10">
    <div className="w-5/6 lg:w-3/4 xl:w-2/3 mx-auto">
      <CSSTransition {...TransitionStyles} transitionAppear active>
        <h5 className="text-harbor-80 uppercase text-sky tracking-wide-2xl">
          <FormattedMessage id="giftcards.category" defaultMessage="Giftcards" />
        </h5>
        <h1 className="text-4xl border-b pb-8">
          <FormattedMessage id="giftcards.completed.header" defaultMessage="Thank you for your purchase" />
        </h1>
        <p className="mt-6">
          <FormattedMessage id="giftcards.completed.giftcardWillBeSentToMailMsg" defaultMessage="Your giftcard will be sent to the following address" />
        </p>
        <div className="flex justify-center">
          <div className="p-6 my-6 bg-grass-60 text-harbor font-bold text-lg">
            { email }
          </div>
        </div>
        <p>
          <FormattedMessage id="giftcards.completed.makeSureEmailIsCorrectMsg" defaultMessage="It's important you make sure that your email address is correct" />
        </p>
        <p className="text-sm text-grey-darker">
          <FormattedMessage id="giftcards.completed.makeSureEmailIsCorrectMsg" defaultMessage="It's important you make sure that your email address is correct" />
          <FormattedMessage id="giftcards.completed.ifEmailNotCorrectInstructionsMsg1" defaultMessage="If your email address is not correct, or if you do not receive the email, you can contact us at" />
          {' '}
          <a href="mailto:info@copenhill.dk" className="text-grey-darker underline font-bold">info@copenhill.dk</a>
          <FormattedMessage id="giftcards.completed.ifEmailNotCorrectInstructionsMsg2" defaultMessage="Please make sure to attach your order number:" />
          &nbsp;
          <strong>
            {stripeOrder.id}
          </strong>
        </p>
      </CSSTransition>        
    </div>
  </div>
)

export default GiftcardsOrderCompleted